// import ApiService from '@/services/api.services'
import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const TerritoryService = {
    getActiveTerritoriesSimpleData: async () => {
        const url = `/api/Territory/GetActiveTerritoriesSimpleData`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    getAllTerritories: async () => {
        const url = `/api/Territory/GetAllTerritories`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    populateTerritoryEditModel: async (id) => {
        const url = `/api/Territory/PopulateTerritoryEditModel?id=${!id?'' : id}`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    saveTerritory: async (payload) => {
        const url = `/api/Territory/SaveTerritory`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    inactiveOrActiveTerritory: async (payload) => {
        const url = `/api/Territory/InactiveOrActiveTerritory`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
}

export default TerritoryService